/**
 * @generated SignedSource<<a9e9119faa020819ce15d7921ecbcbf8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommentDisplayUpdateMutation$variables = {
  content: string;
  id: string;
};
export type CommentDisplayUpdateMutation$data = {
  readonly updateComment: {
    readonly node: {
      readonly content: string;
      readonly edited: boolean;
      readonly id: string;
    };
  };
};
export type CommentDisplayUpdateMutation = {
  response: CommentDisplayUpdateMutation$data;
  variables: CommentDisplayUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "content"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "content"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CommentEdge",
    "kind": "LinkedField",
    "name": "updateComment",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "edited",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentDisplayUpdateMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CommentDisplayUpdateMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "f328add64ee1fb5993cd92e91814633a",
    "id": null,
    "metadata": {},
    "name": "CommentDisplayUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation CommentDisplayUpdateMutation(\n  $id: ID!\n  $content: String!\n) {\n  updateComment(id: $id, input: {content: $content}) {\n    node {\n      id\n      content\n      edited\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5bbfdf4405a450b486964788282d6a94";

export default node;
